import { Component } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'
import { Permissions } from 'src/app/core/enums/permissions.enum'
import { AuthService } from 'src/app/core/services/auth.service'

@Component({
  selector: 'app-construction-sites-data',
  templateUrl: './construction-sites-data.component.html',
  standalone: false,
})
export class ConstructionSitesDataComponent {
  public Layers = Layers
  public isCSLayerVisible: boolean | undefined
  public onDestroy: boolean | undefined = false
  public Permissions = Permissions

  constructor(
    private appState: AppStateService,
    private authService: AuthService,
  ) {
    const layers = this.appState.getState().layers

    if (layers) {
      this.isCSLayerVisible =
        layers?.includes(Layers.ConstructionSites.name) &&
        this.authService.hasPermission(Layers.ConstructionSites.permissions, 'any')
    } else {
      //this.isCSLayerVisible = this.authService.hasPermission(Layers.ConstructionSites.permissions, 'any')
    }

    this.updateQueryParameters()
    this.appState.stateChanged.pipe(takeUntilDestroyed()).subscribe(() => {})
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.ConstructionSites.name:
        this.isCSLayerVisible = !this.isCSLayerVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter((layer) => !layer.includes(Layers.ConstructionSites.name))

    if (this.isCSLayerVisible) {
      layers.push(Layers.ConstructionSites.name)
    }
    this.appState.setState(AppPaths.Internal, {
      layers: layers?.toString(),
    })
  }
}
